import classes from './Button.module.css';


const Button = (props) => {
    return <button onClick={props.onClick} className={classes.button} type={props.buttonType}>{props.buttonName ? props.buttonName : <img src={props.img} alt="" />}</button>
}

export default Button;